import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'
import CartDrawer from './cart-drawer'

class CartCount extends BaseComponent {
  cartDrawer: Nullable<CartDrawer>
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = document.querySelector('cart-page')
    this.cartDrawer = document.querySelector('cart-drawer')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }

    if (this.cartDrawer) {
      this.cartDrawer.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }

    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const newCount = node.querySelector(`#NewCartCount`)

    if (!newCount) {
      return
    }

    const clonedNewCount = newCount.cloneNode(true)

    this.replaceChildren(...clonedNewCount.childNodes)
  }
}

export default CartCount
